<div class="container">

  <div class="header-bar">
    <button mat-icon-button (click)="voltar()" aria-label="Voltar">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span class="header-title">Processo Virtual</span>
  </div>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <div class="conteudo" *ngIf="!loading && processo">

    <!-- Sidebar de documentos -->
    <aside class="sidebar">
      <div class="sidebar-header">
        <mat-icon>folder</mat-icon>
        <span>Processo Virtual</span>
      </div>

      <ul class="lista-documentos">
        <li *ngFor="let doc of processo.documentos; let i = index" (click)="abrirDocumento(doc)"
            [class.selecionado]="documentoAberto === doc">
          <mat-icon class="doc-assinado" *ngIf="doc.assinado" matTooltip="Documento assinado">lock</mat-icon>
          <mat-icon class="doc-icon" *ngIf="!doc.assinado">description</mat-icon>
          <span class="doc-nome">
            {{ doc.nomeArquivo || doc.tipoDescricao || (i + 1) + ' - Documento' }}
          </span>
          <button mat-icon-button class="doc-excluir" (click)="excluirDocumento(doc, $event)" matTooltip="Excluir documento">
            <mat-icon>delete</mat-icon>
          </button>
        </li>
        <li *ngIf="!processo.documentos?.length" class="vazio">
          Nenhum documento anexado.
        </li>
      </ul>
    </aside>

    <!-- Abas -->
    <main class="abas">
      <button mat-button color="primary" (click)="verComposicaoOriginal()">Ver discriminativo original da abertura</button>

      <div class="visualizador-documento" *ngIf="documentoAberto">
        <div class="visualizador-header">
          <button mat-icon-button (click)="fecharDocumento()" aria-label="Voltar" matTooltip="Voltar">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <mat-icon class="doc-icon-header">picture_as_pdf</mat-icon>
          <span class="visualizador-titulo">
            {{ documentoAberto.nomeArquivo || documentoAberto.tipoDescricao || 'Documento' }}
          </span>
          <button mat-button color="primary" (click)="fecharDocumento()">
            <mat-icon>close</mat-icon>
            Fechar
          </button>
        </div>

        <div class="visualizador-corpo">
          <div *ngIf="carregandoDocumento" class="visualizador-loading">
            <mat-spinner diameter="50"></mat-spinner>
          </div>

          <ngx-extended-pdf-viewer
            *ngIf="!carregandoDocumento && documentoBlob"
            [src]="documentoBlob"
            [textLayer]="true"
            [showUnverifiedSignatures]="true"
            [showOpenFileButton]="false"
            height="100%"
            class="visualizador-iframe">
          </ngx-extended-pdf-viewer>
        </div>
      </div>

      <mat-tab-group *ngIf="!documentoAberto" [selectedIndex]="0" animationDuration="0ms">

        <!-- Beneficiário (default) -->
        <mat-tab label="Beneficiário">
          <div class="aba-conteudo">

            <section class="bloco">
              <div class="bloco-header">Dados Servidor</div>
              <div class="bloco-corpo">
                <div class="campo">
                  <label>CPF:</label>
                  <span>{{ processo.servidor?.cpf || '-' }}</span>
                </div>
                <div class="campo">
                  <label>Nome:</label>
                  <span>{{ processo.servidor?.nome || '-' }}</span>
                </div>
                <div class="campo">
                  <label>Nascimento:</label>
                  <span>{{ (processo.servidor?.dataNascimento | date:'dd/MM/yyyy') || '-' }}</span>
                </div>
                <div class="campo">
                  <label>Matrícula:</label>
                  <span>{{ processo.servidor?.matricula || '-' }}</span>
                </div>
                <div class="campo">
                  <label>Orgão:</label>
                  <span>{{ processo.servidor?.orgaoDescricao || processo.servidor?.orgaoSigla || '-' }}</span>
                </div>
                <div class="campo">
                  <label>Sexo:</label>
                  <span>{{ processo.servidor?.sexo || '-' }}</span>
                </div>
              </div>
            </section>

            <section class="bloco">
              <div class="bloco-header">Dados Processo</div>
              <div class="bloco-corpo">
                <div class="campo">
                  <label>Data de Abertura do Processo:</label>
                  <span>{{ (processo.dataAbertura | date:'dd/MM/yyyy') || '-' }}</span>
                </div>
                <div class="campo">
                  <label>Numero do Benefício:</label>
                  <span>{{ processo.numeroBeneficio || '-' }}</span>
                </div>
                <div class="campo">
                  <label>Numero do Processo:</label>
                  <span>{{ processo.numeroProcesso || '-' }}</span>
                </div>
                <div class="campo">
                  <label>Abono Permanencia Aprovado PGE:</label>
                  <span>{{ processo.abonoPermanenciaAprovadoPGE || '-' }}</span>
                </div>
                <div class="campo full">
                  <label>E-mail Setorial:</label>
                  <span>{{ processo.emailSetorial || '-' }}</span>
                </div>
              </div>
            </section>

          </div>
        </mat-tab>

        <!-- Peças: anexar documentos PDF ao processo. Habilitada apenas com o
             processo aberto e tramitado para a setorial. -->
        <mat-tab label="Peças" [disabled]="!pecasHabilitadas">
          <div class="aba-conteudo">
            <section class="bloco">
              <div class="bloco-header">Inserir Peça</div>
              <div class="bloco-corpo peca-form">
                <div class="peca-grid">

                  <!-- Área de upload (clique ou arraste) -->
                  <div class="dropzone"
                    [class.arrastando]="arrastandoPeca"
                    [class.com-arquivo]="!!pecaArquivo"
                    (click)="!pecaArquivo && inputArquivoPeca.click()"
                    (dragover)="onDragOverPeca($event)"
                    (dragleave)="onDragLeavePeca($event)"
                    (drop)="onDropPeca($event)">

                    <ng-container *ngIf="!pecaArquivo">
                      <div class="dz-icone">
                        <mat-icon>cloud_upload</mat-icon>
                      </div>
                      <p class="dz-titulo">Selecionar um arquivo do computador</p>
                      <p class="dz-subtitulo">
                        Arraste o PDF até aqui ou <span class="dz-link">clique para escolher</span>
                      </p>
                    </ng-container>

                    <div class="dz-arquivo" *ngIf="pecaArquivo">
                      <mat-icon class="dz-pdf">picture_as_pdf</mat-icon>
                      <div class="dz-arquivo-info">
                        <span class="dz-arquivo-nome">{{ pecaArquivo.name }}</span>
                        <span class="dz-arquivo-tamanho">{{ formatarTamanho(pecaArquivo.size) }}</span>
                      </div>
                      <button mat-icon-button matTooltip="Remover arquivo"
                        (click)="removerArquivoPeca($event)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>

                    <input #inputArquivoPeca type="file" accept="application/pdf" hidden
                      (change)="onArquivoPecaSelecionado($event)" />
                  </div>

                  <!-- Tipo + inserir -->
                  <div class="peca-lado">
                    <mat-form-field appearance="outline" class="peca-tipo">
                      <mat-label>Tipo do Documento</mat-label>
                      <mat-select [(ngModel)]="pecaTipoSelecionado" required>
                        <mat-option *ngFor="let tipo of tiposPeca" [value]="tipo">
                          {{ tipo }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <p class="peca-hint">
                      <mat-icon>info</mat-icon>
                      A peça será adicionada à pasta do Processo Virtual, na lista ao lado.
                    </p>

                    <button mat-raised-button color="primary" class="peca-inserir"
                      [disabled]="inserindoPeca || !pecaArquivo || !pecaTipoSelecionado"
                      (click)="inserirPeca()">
                      <mat-icon *ngIf="!inserindoPeca">upload_file</mat-icon>
                      {{ inserindoPeca ? 'Inserindo...' : 'Inserir' }}
                    </button>
                  </div>

                </div>
              </div>
            </section>

            <!-- Peças já anexadas ao processo -->
            <section class="bloco">
              <div class="bloco-header">Peças do Processo</div>
              <div class="bloco-corpo pecas-lista">
                <table mat-table [dataSource]="processo.documentos || []" class="mat-elevation-z0"
                  *ngIf="processo.documentos?.length">

                  <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef>Documento</th>
                    <td mat-cell *matCellDef="let doc">
                      <div class="peca-nome">
                        <mat-icon class="peca-nome-icone">picture_as_pdf</mat-icon>
                        <span>{{ doc.nomeArquivo || doc.tipoDescricao || 'Documento' }}</span>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="tipo">
                    <th mat-header-cell *matHeaderCellDef>Tipo</th>
                    <td mat-cell *matCellDef="let doc">{{ doc.tipoDescricao || doc.tipoDocumentoNome || '-' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="dataGeracao">
                    <th mat-header-cell *matHeaderCellDef>Data</th>
                    <td mat-cell *matCellDef="let doc">
                      {{ (doc.dataGeracao | date:'dd/MM/yyyy HH:mm') || '-' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="assinado">
                    <th mat-header-cell *matHeaderCellDef>Assinado</th>
                    <td mat-cell *matCellDef="let doc">
                      <span class="pill" [class.pill-ok]="doc.assinado" [class.pill-pendente]="!doc.assinado">
                        <mat-icon>{{ doc.assinado ? 'lock' : 'schedule' }}</mat-icon>
                        {{ doc.assinado ? 'Sim' : 'Não' }}
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef>Ações</th>
                    <td mat-cell *matCellDef="let doc">
                      <button mat-icon-button color="primary" matTooltip="Visualizar"
                        (click)="abrirDocumento(doc)">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" matTooltip="Excluir"
                        (click)="excluirDocumento(doc, $event)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="colunasPecas"></tr>
                  <tr mat-row *matRowDef="let row; columns: colunasPecas;"></tr>
                </table>

                <div *ngIf="!processo.documentos?.length" class="empty-message">
                  Nenhuma peça anexada ao processo.
                </div>
              </div>
            </section>
          </div>
        </mat-tab>

        <!-- Movimentações -->
        <mat-tab label="Movimentações">
          <div class="aba-conteudo">
            <table mat-table [dataSource]="processo.tramitacoes || []" class="mat-elevation-z2">

              <ng-container matColumnDef="dataTramitacao">
                <th mat-header-cell *matHeaderCellDef>Data Tramitação</th>
                <td mat-cell *matCellDef="let t">
                  {{ (t.dataTramitacao | date:'dd/MM/yyyy HH:mm:ss') || '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="localOrigemNome">
                <th mat-header-cell *matHeaderCellDef>Local Origem</th>
                <td mat-cell *matCellDef="let t">{{ t.localOrigemNome || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="localDestinoNome">
                <th mat-header-cell *matHeaderCellDef>Local Destino</th>
                <td mat-cell *matCellDef="let t">{{ t.localDestinoNome || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="usuario">
                <th mat-header-cell *matHeaderCellDef>Usuário</th>
                <td mat-cell *matCellDef="let t">
                  {{ t.usuarioNome || t.nomeUsuario || t.usuario || '-' }}
                  <p>{{t.descricao}}</p>
                  <p *ngIf="t.cancelada">Cancelada em {{t.dataCancelamento | date:'dd/MM/yyyy HH:mm'}} por {{t.usuarioCancelamento}}: {{t.motivoCancelamento}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let t">
                  <button mat-icon-button color="warn" (click)="excluirTramitacao(t)" [disabled]="t.cancelada" matTooltip="Cancelar última tramitação">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="colunasTramitacoes"></tr>
              <tr mat-row *matRowDef="let row; columns: colunasTramitacoes;"></tr>
            </table>

            <div *ngIf="!processo.tramitacoes?.length" class="empty-message">
              Nenhuma movimentação registrada.
            </div>

            <div class="acoes-rodape">
              <button mat-raised-button color="primary" (click)="abrirDialogTramitar()">
                Tramitar
              </button>
            </div>
          </div>
        </mat-tab>

        <!-- Análise: visível apenas para os perfis Cearaprev Gestor e Gestor CPP -->
        <mat-tab label="Análise" *ngIf="podeVerAnaliseCearaprev">
          <div class="aba-conteudo">

            <section class="bloco">
              <div class="bloco-header">Atualizar dados</div>
              <div class="bloco-corpo analise-form">

                <div class="analise-campos">
                  <mat-form-field appearance="outline" class="analise-status">
                    <mat-label>Status</mat-label>
                    <mat-select [(ngModel)]="analiseStatus">
                      <mat-option *ngFor="let s of statusOpcoes" [value]="s.value">
                        {{ s.label }}
                      </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>flag</mat-icon>
                  </mat-form-field>

                  <mat-form-field appearance="outline"
                    matTooltip="Preenchida automaticamente quando a Casa Civil publica o ato">
                    <mat-label>Data da última publicação</mat-label>
                    <input matInput type="date" [(ngModel)]="analiseDataPublicacao" disabled />
                    <mat-icon matSuffix class="icone-integracao">sync</mat-icon>
                  </mat-form-field>

                  <mat-form-field appearance="outline"
                    matTooltip="Preenchida automaticamente pela integração com o TCE">
                    <mat-label>Data do Registro TCE</mat-label>
                    <input matInput type="date" [(ngModel)]="analiseDataRegistroTce" disabled />
                    <mat-icon matSuffix class="icone-integracao">sync</mat-icon>
                  </mat-form-field>
                </div>

                <p class="analise-hint">
                  <mat-icon>info</mat-icon>
                  As datas de publicação e do registro TCE são preenchidas pelas integrações
                  com a Casa Civil e com o TCE.
                </p>

                <div class="analise-salvar">
                  <button mat-raised-button color="primary"
                    [disabled]="salvandoAnalise" (click)="salvarAnalise()">
                    <mat-icon *ngIf="!salvandoAnalise">save</mat-icon>
                    {{ salvandoAnalise ? 'Salvando...' : 'Salvar' }}
                  </button>
                </div>

              </div>
            </section>

            <section class="bloco">
              <div class="bloco-header">Ato</div>
              <div class="bloco-corpo analise-acoes">

                <button class="acao-card" type="button" (click)="publicarAtoEdweb()">
                  <span class="acao-icone verde"><mat-icon>publish</mat-icon></span>
                  <span class="acao-textos">
                    <span class="acao-titulo">Ato no Edweb</span>
                    <span class="acao-descricao">Enviar o ato para publicação no Edweb</span>
                  </span>
                  <mat-icon class="acao-seta">chevron_right</mat-icon>
                </button>

                <button class="acao-card" type="button" (click)="gerarAtoSemEfeito()">
                  <span class="acao-icone vermelho"><mat-icon>block</mat-icon></span>
                  <span class="acao-textos">
                    <span class="acao-titulo">Gerar ato sem efeito</span>
                    <span class="acao-descricao">Gerar o ato tornando sem efeito o anterior</span>
                  </span>
                  <mat-icon class="acao-seta">chevron_right</mat-icon>
                </button>

                <button class="acao-card" type="button" (click)="abrirDialogDatasAtoSemEfeito()">
                  <span class="acao-icone azul"><mat-icon>event</mat-icon></span>
                  <span class="acao-textos">
                    <span class="acao-titulo">Adicionar Datas do Ato sem efeito</span>
                    <span class="acao-descricao">Informar a data do ato e da publicação no D.O.E.</span>
                  </span>
                  <mat-icon class="acao-seta">chevron_right</mat-icon>
                </button>

              </div>
            </section>

          </div>
        </mat-tab>

        <!-- Assinar os Documentos -->
        <mat-tab label="Assinar os Documentos">
          <div class="aba-conteudo">
            <div *ngIf="getDocumentosPendentesAssinatura().length === 0" class="empty-message">
              Nenhum documento pendente de assinatura.
            </div>

            <ng-container *ngIf="getDocumentosPendentesAssinatura().length > 0">
              <ul class="lista-documentos">
                <li *ngFor="let doc of getDocumentosPendentesAssinatura()">
                  <mat-icon class="doc-icon">description</mat-icon>
                  <span class="doc-nome">{{ doc.nomeArquivo || doc.nome || 'Documento' }}</span>
                  <button mat-button color="primary" (click)="assinarTodos(doc)" [disabled]="assinandoLote">Assinar este documento</button>
                  <mat-progress-spinner *ngIf="doc.signing" diameter="18" mode="indeterminate"></mat-progress-spinner>
                </li>
              </ul>

              <button mat-raised-button color="primary"
                (click)="assinarTodos()"
                [disabled]="assinandoLote">
                <mat-icon>edit_document</mat-icon>
                {{ assinandoLote
                    ? 'Assinando ' + progressoAssinatura.atual + '/' + progressoAssinatura.total + '...'
                    : 'Assinar todos' }}
              </button>
            </ng-container>
          </div>
        </mat-tab>

        <!-- Histórico Status -->
        <mat-tab label="Histórico Status">
          <div class="aba-conteudo">
            <table mat-table [dataSource]="processo.historicoStatus || []" class="mat-elevation-z2"
              *ngIf="processo.historicoStatus?.length">

              <ng-container matColumnDef="dataStatus">
                <th mat-header-cell *matHeaderCellDef>Data / Hora</th>
                <td mat-cell *matCellDef="let h">
                  {{ (h.dataStatus | date:'dd/MM/yyyy HH:mm:ss') || '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="statusAnalise">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let h">{{ h.statusAnalise || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="usuarioResponsavel">
                <th mat-header-cell *matHeaderCellDef>Usuário Responsável</th>
                <td mat-cell *matCellDef="let h">{{ h.usuarioResponsavel || '-' }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="colunasHistorico"></tr>
              <tr mat-row *matRowDef="let row; columns: colunasHistorico;"></tr>
            </table>

            <div *ngIf="!processo.historicoStatus?.length" class="empty-message">
              Nenhum registro de status para este processo.
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Finalizar saneamento">
          <app-saneamento-processo [idBeneficio]="processo.idBeneficio"></app-saneamento-processo>
        </mat-tab>
      </mat-tab-group>
    </main>

  </div>
</div>
